import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Guards the influencer dashboard route. If the user has no influencer code,
 * redirect home so the page can't be reached by typing its URL. The backend
 * enforces the same thing (GET /influencer/me 404s for non-influencers), so
 * this is defense-in-depth, not the only gate.
 */
export const InfluencerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!(user as any)?.is_influencer) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default InfluencerRoute;
